export const REASON_NO_FACTORS = 'NO_FACTORS';

export interface MfaEligibilityResult {
  eligible: boolean;
  reason?: string;
  factors?: string[];
}

export function isNoFactorsEligibility(result: MfaEligibilityResult): boolean {
  if (result.reason === REASON_NO_FACTORS) {
    return true;
  }

  return Boolean(result.eligible && (!result.factors || result.factors.length === 0));
}
